import { Switch, Route } from "wouter";
import { Toaster } from "@/components/ui/toaster";
import Navigation from "@/components/layout/navigation";
import Footer from "@/components/layout/footer";
import Home from "@/pages/home";
import About from "@/pages/about";
import Rules from "@/pages/rules";
import Committee from "@/pages/committee";
import History from "@/pages/history";
import Membership from "@/pages/membership";
import Apply from "@/pages/apply";
import Weather from "@/pages/weather";
import Gallery from "@/pages/gallery";
import PrivacyPolicy from "@/pages/privacy-policy";
import TermsOfService from "@/pages/terms-of-service";
import Contact from "@/pages/contact";
import NotFound from "@/pages/not-found";

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-1">
        <Switch>
          <Route path="/" component={Home} />
          <Route path="/about" component={About} />
          <Route path="/rules" component={Rules} />
          <Route path="/committee" component={Committee} />
          <Route path="/history" component={History} />
          <Route path="/membership" component={Membership} />
          <Route path="/apply" component={Apply} />
          <Route path="/weather" component={Weather} />
          <Route path="/gallery" component={Gallery} />
          <Route path="/contact" component={Contact} />
          <Route path="/privacy-policy" component={PrivacyPolicy} />
          <Route path="/terms-of-service" component={TermsOfService} />
          <Route component={NotFound} />
        </Switch>
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;